import React from 'react';
import { PSmall, Subtitle } from '@etiquette-ui/typography';
import ImageUpload from 'components/ImageUpload';
import { IMAGE_SHAPES } from 'components/ImageUpload/imageShapes';
import FormSection from 'containers/Form/FormSection';
import ImageSectionContainer from 'pages/MenuItems/containers/ImageSectionContainer';
import useI18n from 'i18n/useI18n';
import styled from 'styled-components';
import ITEM_KEYS from '../keys';

const Image = styled(ImageUpload)`
  width: 250px;
`;

const HintContainer = styled.div`
  padding-top: 12px;

  @media( min-width: 768px ){
    padding: 0px;
    margin-left: 20px;
  }
`;

const Sponsor = ({ formData, handleItemInfo }) => {
  const { translate } = useI18n();

  return (
    <FormSection>
      <Subtitle>{translate('Sponsor')}</Subtitle>
      <ImageSectionContainer style={{margin: '15px 0px 10px'}}>
        <Image
          text={translate('Add Logo')}
          altText={translate('Edit Logo')}
          src={formData[ITEM_KEYS.LOGO]}
          onChange={(value) => handleItemInfo(ITEM_KEYS.LOGO, value)}
          shape={IMAGE_SHAPES.ROUNDED_RECTANGLE}
        />
        <HintContainer>
          <PSmall>{translate('images_disclaimer')}</PSmall>
        </HintContainer>        
      </ImageSectionContainer>
    </FormSection>
  );
};

export default Sponsor;
